import React from "react"
import { useAtom as GetAtom } from "jotai"
import { ImageFromJSONTyped, Item } from "../../libs/api/backend/src"
import { checkoutIsStep0 } from "../../store/checkout"
import { DefaultImageUrl } from "../../libs/vars/url"
import { formatNumber, formatPriceKZT } from "@malond/utils"
import { cn } from "@malond/ui/utils"

interface Props {
  items: Array<Item>
  onClickItem: (item: Item, count: number) => void
}

function CheckoutItemStackedList({ items, onClickItem }: Props) {
  const [isStep0] = GetAtom(checkoutIsStep0)

  return (
    <div className="overflow-hidden">
      <table className="w-full table-fixed">
        <tbody className="divide-y divide-border">
          {items.map((item) => {
            const itemImage = ImageFromJSONTyped(item.image, false)
            const hasDiscount = item.priceOut !== item.priceDiscount

            return (
              <tr
                key={item.id}
                className={cn("transition-colors", {
                  "hover:cursor-pointer hover:bg-muted/50": isStep0,
                })}
                onClick={() => (isStep0 ? onClickItem(item, 1) : null)}
              >
                {/* Left side */}
                <td className="w-16 px-4 py-3 sm:pl-6">
                  {/* Image */}
                  <img
                    className="h-12 w-12 flex-none rounded-md border border-border bg-muted object-cover"
                    src={
                      (itemImage && itemImage.urlThumbnail) || DefaultImageUrl
                    }
                    alt={item.title}
                  />
                </td>

                {/* Center side */}
                <td className="px-2 py-3">
                  {/* Title */}
                  <p className="truncate text-sm font-semibold text-foreground">
                    {item.title}
                  </p>

                  {/* Barcode */}
                  <p className="text-xs text-muted-foreground">
                    {item.barcode}
                  </p>

                  {/* Count */}
                  <p className="mt-0.5 text-xs font-medium text-muted-foreground">
                    × {formatNumber(item.count)}
                  </p>
                </td>

                {/* Right side */}
                <td className="w-32 py-3 pr-4 text-right sm:pr-6">
                  {/* Price out */}
                  <p
                    className={cn("truncate text-sm", {
                      "font-bold text-foreground": !hasDiscount,
                      "text-xs text-muted-foreground line-through": hasDiscount,
                    })}
                  >
                    {formatPriceKZT(item.priceOut)}
                  </p>

                  {/* Price discount */}
                  {hasDiscount && (
                    <p className="truncate text-sm font-bold text-emerald-600 dark:text-emerald-400">
                      {formatPriceKZT(item.priceDiscount)}
                    </p>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default CheckoutItemStackedList
